import { type MantineThemeOverride } from '@mantine/core'

import { commonTheme } from './common'

export const webTheme: MantineThemeOverride = {
	...commonTheme,
}
